<template>
<b-tabs card v-if="quotatons">
  <b-tab title="Items List">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{ $t('delivery.quotation.courier') }}</th>
            <th>{{ $t('delivery.quotation.total_cost') }}</th>
            <th>{{ $t('delivery.quotation.free_cost') }}</th>
            <th>{{ $t('delivery.quotation.currency') }}</th>
            <th>{{ $t('delivery.quotation.ddp_surcharge') }}</th>
            <th>{{ $t('delivery.quotation.fuel_surcharge') }}</th>
            <th>{{ $t('delivery.quotation.pod_fee') }}</th>
            <th>{{ $t('delivery.quotation.others') }}</th>
            <th>{{ $t('delivery.quotation.status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(quotaton, index) in quotatons" :key="index">
            <td>{{ quotaton.courier }}</td>
            <td>{{ quotaton.total_cost }}</td>
            <td>{{ quotaton.free_cost }}</td>
            <td>{{ quotaton.currency }}</td>
            <td>{{ quotaton.ddp_surcharge }}</td>
            <td>{{ quotaton.fuel_surcharge }}</td>
            <td>{{ quotaton.pod_fee }}</td>
            <td>
              <span v-for="(other, index) in quotaton.others" :key="index">
                {{ index }} - {{ other}}
              </span>
            </td>
            <td>{{ quotaton.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-tab>
</b-tabs>
</template>
<script>
export default {
  name: 'DeliveryQuotation',
  props: {
    index: {
      type: String,
      default: ''
    },
    quotatons: {
      type: Object
    }
  }
}
</script>
